var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"basic-layout"},[_c('el-header',{staticClass:"header-layout"},[_c('base-header',{ref:"baseHeader"})],1),_c('el-main',{staticClass:"content-layout"},[_c('router-view')],1),_c('public-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }